import React, { useContext } from 'react'
import EnvInput from "app/React/Components/EnvInput";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function EnvZipCodeInput(props) {
  const {
    order,
    strings,
    zipCodes,
    setOrder
  } = useContext(ConfiguratorContext)

  const payment_strings = strings.payment_form ?? {}

  const onChange = (e) => {
    if (Object.keys(zipCodes).length === 0) {
      return
    }

    const zipCode = e.target.value
    let city = ''

    if (typeof zipCode !== 'string' || zipCode.length !== 4) {
      city = ''
    } else {
      if (!zipCodes.hasOwnProperty(zipCode)) {
        city = payment_strings.zip_codes.unknown
      } else {
        city = zipCodes[zipCode]
      }
    }

    order.city_address = city
    setOrder({ ...order })
  }

  return (
    <>
      <label
        htmlFor='postnumber_address'
        className='config-form__input-label'
      >
        {props.label}
      </label>
      <EnvInput
        id='postnumber_address'
        name='postnumber_address'
        placeholder={props.placeholder}
        autoComplete='postal-code'
        onChange={onChange}
        {...props}
      />
    </>
  )
}

export default EnvZipCodeInput
